module.exports = __webpack_public_path__ + "img/src/assets/images/tgy.png";